import { useMutation } from "@tanstack/react-query";
import { dfetch } from "src/utils/dfetch.ts";

const ADMIN_TESTS = "/api/admin-actions/tests";

/** DELETE `/api/admin-actions/tests` — body shape varies by caller (env-wide vs app-scoped). */
export type DeleteAdminTestsBody = {
  env_name: string;
  app_id?: number;
  /** When `false`, non-auto tests are included in deletion scope. */
  is_auto?: boolean;
};

/**
 * DELETE `/api/admin-actions/delete-alerts`
 */
export const useDeleteEnvAlertsMutation = () => {
  return useMutation({
    mutationFn: (env_name: string) =>
      dfetch(
        "/api/admin-actions/delete-alerts",
        { env_name },
        "DELETE"
      ).invalidate(),
  });
};

/**
 * GET `/api/admin-actions/send-daily-incident-report`
 */
export const useSendDailyIncidentReportMutation = () => {
  return useMutation({
    mutationFn: () => dfetch("/api/admin-actions/send-daily-incident-report"),
  });
};

/** GET `/api/admin-actions/simulate-alerts` — env-level or app + env. */
export type SimulateAlertsBody = {
  env_name: string;
  app_id?: number;
};

/**
 * GET `/api/admin-actions/simulate-alerts`
 */
export const useSimulateAlertsMutation = () => {
  return useMutation({
    mutationFn: (body: SimulateAlertsBody) =>
      dfetch("/api/admin-actions/simulate-alerts", body, "GET").invalidate(),
  });
};

/**
 * DELETE `/api/admin-actions/tests`
 */
export const useDeleteAdminTestsMutation = () => {
  return useMutation({
    mutationFn: (body: DeleteAdminTestsBody) =>
      dfetch(ADMIN_TESTS, body, "DELETE").invalidate(),
  });
};

/** GET `/api/admin-actions/regenerate-tests` — pipeline menu uses `app_id`; metrics cell uses metric + app context. */
export type RegenerateTestsBody =
  | { app_id: number }
  | {
      metric_id: number;
      app_name: string | undefined;
      env_name: string | undefined;
    };

/**
 * GET `/api/admin-actions/regenerate-tests`
 */
export const useRegenerateTestsMutation = () => {
  return useMutation({
    mutationFn: (body: RegenerateTestsBody) =>
      dfetch("/api/admin-actions/regenerate-tests", body, "GET").invalidate(),
  });
};

/**
 * `/api/admin-actions/send-monthly-sla-report` (same method as previous inline `dfetch`).
 */
export const useSendMonthlySlaReportMutation = () => {
  return useMutation({
    mutationFn: () => dfetch("/api/admin-actions/send-monthly-sla-report"),
  });
};
